module.exports = __webpack_public_path__ + "fonts/SUIT-Thin.e1f697c8.woff2";